export * from "./alternative-content.component";
export * from "./alternative-content.model";
